export default __webpack_public_path__ + "static/media/banner3.6b6f9f3a.png";